var _a;
import { jsx as _jsx } from "react/jsx-runtime";
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { useMediaStore } from '../store/media.store';
import { usePlayerStore } from '../store/player.store';
import { usePlaylistStore } from '../store/playlist.store';
import { usePostStore } from '../store/post.store';
import { useSiteStore } from '../store/site.store';
// Importing 3rd party dependencies
import * as React from 'react';
// Getting player data
const mediaData = window.cbaCurrent;
const localeData = ((_a = document.cookie.match('(^|;)\\s*' + 'cba_language' + '\\s*=\\s*([^;]+)')) === null || _a === void 0 ? void 0 : _a.pop()) || 'en';
const playlistData = window.cbaPlaylist;
const postData = window.cbaPost;
const siteData = window.cbaSite;
export function DataProvider({ children }) {
    // Initializing media store
    const { setMedia } = useMediaStore(useShallow((state) => ({
        setMedia: state.setMedia,
    })));
    // Initializing player store
    const { setLocale } = usePlayerStore(useShallow((state) => ({
        setLocale: state.setLocale,
    })));
    // Initializing playlist store
    const { setPlaylist } = usePlaylistStore(useShallow((state) => ({
        setPlaylist: state.setPlaylist,
    })));
    // Initializing post store
    const { setPost } = usePostStore(useShallow((state) => ({
        setPost: state.setPost,
    })));
    // Initializing site store
    const { setSite } = useSiteStore(useShallow((state) => ({
        setSite: state.setSite,
    })));
    // Adding data to all stores
    React.useEffect(() => {
        setLocale(localeData);
        setMedia(mediaData);
        setPlaylist(playlistData);
        setPost(postData);
        setSite(siteData);
    }, [setLocale, setMedia, setPlaylist, setPost, setSite]);
    return _jsx(React.Fragment, { children: children });
}
